document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

(() => {
  const body = document.body;
  const scrim = document.querySelector('[data-drawer-scrim]');

  const closeDrawers = () => {
    document.querySelectorAll('[data-drawer].is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('[data-drawer-open][aria-expanded="true"]').forEach((button) => {
      button.setAttribute('aria-expanded', 'false');
    });
    scrim?.classList.remove('is-visible');
    body.classList.remove('drawer-open');
  };

  const openDrawer = (id, trigger) => {
    closeDrawers();
    const drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    trigger?.setAttribute('aria-expanded', 'true');
    scrim?.classList.add('is-visible');
    body.classList.add('drawer-open');
    drawer.querySelector('input, button, a')?.focus();
  };

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-drawer-open]');
    if (openButton) {
      event.preventDefault();
      openDrawer(openButton.dataset.drawerOpen, openButton);
      return;
    }

    if (event.target.closest('[data-drawer-close]') || event.target.closest('[data-mobile-link]')) {
      closeDrawers();
    }
  });

  scrim?.addEventListener('click', closeDrawers);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeDrawers();
  });

  document.querySelectorAll('[data-localization-select]').forEach((select) => {
    select.addEventListener('change', () => select.form?.submit());
  });
})();
